import Vue from 'vue';

import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';

export default {
  ...buildFetchMutations(['fetchTimeLogs', 'fetchRunningTimeLog', 'fetchAllRunningTimeLog']),
  ...buildCreateMutations(['createTimeLog']),
  ...buildUpdateMutations(['updateTimeLog', 'deleteTimeLog']),

  setContext: (state, payload = null) => {
    Vue.set(state, 'context', payload);
  },

  openDetailsModal: (state, payload = null) => {
    Vue.set(state, 'detailsModalOpened', true);
    Vue.set(state, 'current', payload);
  },

  closeDetailsModal: (state) => {
    Vue.set(state, 'detailsModalOpened', false);
    Vue.set(state, 'current', null);
  },

  openManualModal: (state, payload = null) => {
    Vue.set(state, 'manualModalOpened', true);
    Vue.set(state, 'current', payload);
  },

  closeManualModal: (state) => {
    Vue.set(state, 'manualModalOpened', false);
    Vue.set(state, 'current', null);
  },

    // --- startTimer action ---
  startTimerPending: (state) => {
    Vue.set(state, 'starting', true);
  },

  startTimerSuccess: (state) => {
    Vue.set(state, 'starting', false);
  },

  startTimerError: (state) => {
    Vue.set(state, 'starting', false);
  },

  // --- stopTimerLog action ---
  stopTimerPending: (state) => {
    Vue.set(state, 'stopping', true);
  },

  stopTimerSuccess: (state) => {
    Vue.set(state, 'stopping', false);
  },

  stopTimerError: (state) => {
    Vue.set(state, 'stopping', false);
  },

  openFormModal: (state, payload = null) => {
    Vue.set(state, 'current', payload);
    Vue.set(state, 'formModalOpened', true);
  },

  closeFormModal: (state) => {
    Vue.set(state, 'current', null);
    Vue.set(state, 'formModalOpened', false);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/timeLog/mutations.js